import { FormGroup } from '@angular/forms';
import { ApplianceDetailsSteppedIpsForm } from './appliance-details-stepped-ips-form.interface';

export type ApplianceDetailsSteppedIpsFormValue = ReturnType<
  FormGroup<ApplianceDetailsSteppedIpsForm>['getRawValue']
>;
